export type FetchStripeOnboardingLinkResponse = {
  onboardingLink: string;
};

export async function fetchStripeOnboardingLink(

): Promise<FetchStripeOnboardingLinkResponse> {
  try {
    const response = await fetch(`/api/proxy/v3/stripe/links`, {
      method: 'GET',
    });

    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not retrieve onboarding link from Stripe.`);
  } catch (err) {
    throw new Error(err.message);
  }
}
